import { Injectable, Injector, NgZone } from '@angular/core';
import { EditTemplateMarketingMenuViewModel } from '../edit-template-marketing-menu-view-model';
import { TemplateDomainModel } from '../../../../../../domainModels/template-domain-model';
import { LocationDomainModel } from '../../../../../../domainModels/location-domain-model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditSmartPlaylistMenuViewModel } from '../../../../../menu/components/edit-menu/edit-marketing-menu/edit-smart-playlist-menu/edit-smart-playlist-menu-view-model';
import { WebSocketService } from '../../../../../../services/web-socket.service';
import { ToastService } from '../../../../../../modules/toasts/service/toast.service';

@Injectable()
export class EditTemplateMarketingSmartPlaylistMenuViewModel extends EditTemplateMarketingMenuViewModel {
  constructor(
    protected override editMenuViewModel: EditSmartPlaylistMenuViewModel,
    templateDomainModel: TemplateDomainModel,
    locationDomainModel: LocationDomainModel,
    toastService: ToastService,
    webSocketService: WebSocketService,
    ngZone: NgZone,
    ngbModal: NgbModal,
    injector: Injector
  ) {
    super(
      editMenuViewModel,
      templateDomainModel,
      locationDomainModel,
      toastService,
      webSocketService,
      ngZone,
      ngbModal,
      injector
    );
  }

  /**
   * This is being used via "viewModel | method: 'getEditMenuViewModel'" in the template.
   * Don't remove it even if the IDE says it's unused, because it is being used.
   */
  getEditMenuViewModel(): EditSmartPlaylistMenuViewModel {
    return this.editMenuViewModel;
  }
}
